import { Card, CardContent } from '@/components/ui/card';

function formatMoney(n, decimals = 2) {
  return `$${Number(n || 0).toLocaleString(undefined, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })}`;
}

export default function BusinessValueHero({ savings, tokenUsage }) {
  if (!savings || !tokenUsage) return null;

  const tickets = savings.ticket_count ?? 0;
  const manual = savings.total_manual_cost ?? 0;
  const llm = savings.total_llm_cost ?? 0;
  const net = savings.total_savings ?? 0;
  const perTicket = tickets > 0 ? net / tickets : 0;
  const cheaper = llm > 0 ? manual / llm : 0;
  const reduction = manual > 0 ? ((manual - llm) / manual) * 100 : 0;

  return (
    <Card
      className="overflow-hidden border-cp-line bg-cp-surface"
      data-testid="bv-hero"
    >
      <CardContent className="grid gap-6 p-6 md:grid-cols-[1.35fr_1fr] md:items-center">
        <div>
          <span className="inline-flex items-center rounded-full border border-cp-line bg-cp-inset px-3 py-1 text-xs font-semibold uppercase tracking-wide text-cp-ok">
            Value delivered
          </span>
          <h2 className="mt-4 text-2xl font-bold leading-snug tracking-tight md:text-[1.65rem]">
            Halo resolved {tickets} ticket{tickets === 1 ? '' : 's'} for{' '}
            <span className="text-cp-indigo">{formatMoney(llm, llm < 1 ? 4 : 2)}</span>
            <br className="hidden sm:block" />
            {' '}that would have cost{' '}
            <span className="text-cp-mod">{formatMoney(manual)}</span> through manual process.
          </h2>
        </div>
        <div className="flex flex-col items-start border-t pt-4 md:items-end md:border-l md:border-t-0 md:pl-6 md:pt-0">
          <div className="text-4xl font-extrabold tracking-tight text-cp-ok md:text-5xl">
            {formatMoney(net)}
          </div>
          <p className="mt-1 text-sm text-muted-foreground">
            net savings
            {tickets > 0 && <> · {formatMoney(perTicket)} saved per ticket</>}
          </p>
          <div className="mt-3 flex flex-wrap gap-2">
            {cheaper >= 2 && (
              <span className="rounded-full border border-cp-mod bg-cp-inset px-3 py-1 text-xs font-bold text-cp-mod">
                {Math.round(cheaper).toLocaleString()}× cheaper
              </span>
            )}
            {reduction > 0 && (
              <span className="rounded-full border border-cp-line bg-cp-inset px-3 py-1 text-xs font-bold text-cp-ok">
                {reduction.toFixed(1)}% cost reduction
              </span>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
